
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import EventsContainerCard from '../../components/events/contianer-card';

export default function Events() {
  return (
    <Container>
      <Row className='mb-3'>
        <Col className='text-center'>
          <Link
            to='/events/create'
            className='btn btn-outline-light'>
            Create New Event <FaPlus />
          </Link>
        </Col>
      </Row>
      <EventsContainerCard />
    </Container>
  )
}
